
import {map,switchMap,catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AngularTokenService } from '@lakshvairav/angular-token';

//import {AjaxService} from '../shared/ajax.service';
import { Router, NavigationStart } from '@angular/router';
import { environment } from '../../environments/environment';


 // in imports

import { Observable ,  Subject , throwError} from "rxjs";
import { Location } from '@angular/common';


import { KeyValue } from '../shared/key-value';
import { HttpClient,HttpErrorResponse } from '@angular/common/http';
import { filter } from 'rxjs/operators';

import { OnboardService } from './onboard.service';

import { CacheService } from './cache.service';
// import 'rxjs/add-session/operator/toPromise';

// This service contains methods related to authoization, routeguards
@Injectable()
export class AuthorizationService {
  requests: string[] = [];
  licenceRejected: boolean;
  init_pwd_changed: boolean;
  sessions: any;
  error_msg_agreement_rejected = '';
  requestSent: Subject<string> = new Subject<string>();
  requestCompleted: Subject<string> = new Subject<string>();
  work_session: any;
  logoutFromDeactivate = false; //used in sec, loans etc forms deactivate guard
  logoutTimerStarted = false;
  constructor(private router: Router, private _tokenService: AngularTokenService,private onboardDataService:OnboardService,
    private KeyValueService: KeyValue,  private location: Location, private http: HttpClient,private CacheService: CacheService ) {
      this.checkIfLoggedoutInDupTab();
      this.router.events
        .pipe(filter(event => event instanceof NavigationStart))
        .subscribe(event => {
        if (!router.navigated) {
          localStorage.setItem('refreshed','true');
          console.log('set refreshed');
          setTimeout(()=>{
            localStorage.removeItem('refreshed');
            console.log('rem refreshed');
          },6000);
        // Handle the browser refresh event here
        console.log('The browser was refreshed');
        }
        });
  }

startTimer(idle_time=180000){
     const that=this;
     let si = 0 //(typeof setInterval) //undefined;
    // let idle_time = 10000 //1800000
    let start_time = new Date().getTime();
    const clickHandler = function(){
      start_time = new Date().getTime();
      console.log('setting new time ...'+start_time);
    }
    const checkhandler = function(){
      const now = new Date().getTime();
      if (now - start_time > idle_time){
        console.log('idle time...up');
        document.removeEventListener('click', clickHandler);
        clearInterval(si);
        that.logout();
      }
    }
    document.addEventListener('click', clickHandler);
    si = setInterval(checkhandler, 3000);
 }

  invalidRoute(): void {
    this.router.navigate([KeyValue.signinPath]);
  }
  // Event, Calls api to update use agreed terms to true
  agreeTerms(): void {
    let that = this;
    this.get(KeyValue.api_agree_terms).pipe(map(res => res)).subscribe(
      res => { this.licenceRejected = false; this.router.navigate([KeyValue.changePasswordPath]); },
      error => this.logout()
    );
  }

  passwordChanged(): void {
    this.get(KeyValue.api_change_password).pipe(map(res => res)).subscribe(
      res => {
        this.init_pwd_changed = true;
        //console.log('sdasfdf ' + res);
      },
      error => this.logout()
    );
  }

  current_category() {
    try{
    const user_data = JSON.stringify(this._tokenService.currentUserData);
    return (JSON.parse(user_data).category);
    }catch(e){
      return '';
    }

  }

  // This methods redirects to user dashboard based on user role
  grantAccess() {
    switch (this.getCRole()) {
      case 'Admin': {
        this.router.navigate([KeyValue.adminPath]);
        break;
      }
      case 'Instructor': {
        this.router.navigate([KeyValue.instructorPath]);
        break;
      }
      case 'Student': {
        //console.log(' in grant accss');
        this.router.navigate([KeyValue.studentPath]);
        break;
      }
      case 'InstructorAdmin': {
        this.router.navigate([KeyValue.instructorAdminPath]);
        break;
      }
      default: {
        this.router.navigate(['/']);
      }
    }
  }

  setOnboardValues(res): void {
    if (res.onboard === 'licence') {
      this.licenceRejected = true;
      this.init_pwd_changed = false;
    }
    if (res.onboard === 'password') {
      this.licenceRejected = false;
      this.init_pwd_changed = false
    }
    if (res.onboard === 'home') {
      this.licenceRejected = false;
      this.init_pwd_changed = true
    }
    if (res.decision_active === false) {
      this.logout()
    }


  }

  checkForInitSteps(): void {
    //console.log('chk for inint steps');
    //console.log(this.licenceRejected );
    //console.log(this.init_pwd_changed);
    if (this.licenceRejected === true) {
      this.router.navigate([KeyValue.licencePath])
    } else if (this.init_pwd_changed === false) {
      //console.log(' in pwd change navigate '+ KeyValue.changePasswordPath);
      this.router.navigate([KeyValue.changePasswordPath])
    }
  }

  getCRole(): string {
      let crole = 'superman';
      if(this._tokenService.currentUserData != null ){
        crole = this._tokenService.currentUserData.nickname;
        console.log('not using cud .... '+crole)

      } else {
        try{
          const cud =  JSON.parse(localStorage.getItem('currentUserData'));
          crole = cud.data.nickname
          // console.log('using cud .... '+crole)
        }catch(ee){console.log('cud eror');}
      }
    return crole;
  }

  getID(): number {
      let cid = 0;
      if(this._tokenService.currentUserData != null ){
        cid = this._tokenService.currentUserData.id;

      } else {
        try{
          const cud =  JSON.parse(localStorage.getItem('currentUserData'));
          cid = cud.data.id
        }catch(ee){console.log('cud eror');}
      }
    return cid;
  }


  getEmail(): string {
    let email = '';
    if(this._tokenService.currentUserData != null ){
      email = this._tokenService.currentUserData.uid;
      // console.log('not using cud .... '+email)

    } else {
      try{
        const cud =  JSON.parse(localStorage.getItem('currentUserData'));
        email = cud.data.uid
        // console.log('using cud .... '+email)
      }catch(ee){console.log('cud eror');}
    }
   return email;
  }

  getRole(roles): string {
    if (typeof roles === 'string') {
      return roles;
    }
    else {
      let crole = this.getCRole(); //this._tokenService.currentUserData.nickname;
      if (roles.includes(crole)) {
        return crole
      } else {
        return 'norole'
      }
    }
  }

  checkPermissions(roles, path): boolean {
    console.log('chk perm.....'+path);
    let role = this.getRole(roles);
    if (!this._tokenService.userSignedIn()) {
      return false;
    } else {
      let crole = this.getCRole();
      let href = window.location.href;

      if (crole == 'Student' && (href.includes('/admin') || href.includes('/instructor'))) {
        return false;
      }

      if (role === KeyValue.allRole) {
        //console.log('in all role');
        if (path === KeyValue.licencePath && this.licenceRejected === true) {
          return true
        } else if ((path === KeyValue.changePasswordPath && this.init_pwd_changed === false)
          || (path === KeyValue.changePasswordPathSubmit)) {
          return true
        } else {
          return true
        }

      } else if (role === crole) {
        //console.log('user all ok');
        if (this.licenceRejected || !this.init_pwd_changed) {
          //console.log('user all ok 1');
          this.checkForInitSteps();
          return false
        } else {
          return true;
        }
      } else {
        //console.log('user role mismatch');
        // this.checkForInitSteps();
        this.grantAccess();
        return false;
      }
      // return true;
    }
  }

  error_handle_func() {
    this.router.navigate([KeyValue.signinPath])
  }

  checkIfLoggedoutInDupTab(){
    setInterval(() => {
      // console.log('checkIfLoggedoutInDupTab'+localStorage.getItem('uid'));
      if(localStorage.getItem('uid') === null && this.location.path()!='/sign-in'
          && this.location.path()!='/forgot-password'
          && this.location.path()!='/forgot-password-submit' ){
        console.log(this.location.path()+'1');
          window.location.href = '/';
      }
    }, 5000);
  }
  checkForDuplicateTab(){
    let user_bk = localStorage.getItem('uid');
    const cur_user_data = this._tokenService.currentUserData;
    if (cur_user_data === undefined || cur_user_data === null) {
      return false;
    }else {
    return (cur_user_data.uid !== user_bk && user_bk !== null);
    }
  }

  checkForActivation(role, path): Observable<boolean> {
    // Check for duplicate tab
    if (this.checkForDuplicateTab()) {
      window.location.href = '/';
    }
    else{
      let userId = null;
      let cachedOnboardData = null;
      try{
        const cud = JSON.parse(localStorage.getItem('currentUserData'));
        userId = cud.data.id
        console.log("current user id",userId);
        cachedOnboardData =  this.onboardDataService.getCachedOnboardData(userId);
      }catch(eer){console.log("error",eer);}
        if(cachedOnboardData && this.onboardDataService.isValidCachedData(cachedOnboardData) && cachedOnboardData.onboard === 'home') {
            this.setOnboardValues(cachedOnboardData);
            return new Observable<boolean>(observer => observer.next(this.checkPermissions(role, path)));
          }
        else{
        // If no cached data or onboard key is not 'home', make API call
        const result2: Observable<boolean> = this.get(KeyValue.api_onboard).pipe(
          map(
            res1 => {
              console.log(" window.location.href true", res1);
              if (res1['_body'] === 'null') {
                this.error_handle_func();
                return false; // Return a boolean value here
              } else {
                var res = res1;
                this.onboardDataService.cacheOnboardData(userId,res);// Cache the onboard data in localStorage for 3 minutes
                this.setOnboardValues(res);
                return this.checkPermissions(role, path);
              }
            },
            error => {
              window.location.href = '/';
              console.log('fail');
              return false; // Return a boolean value here
            }
          )
        );
        return result2; // Return the result2 observable
      }
    }
  }


  // for updating time remaining for student.
  update_decision_set_data() {
    this.get(KeyValue.decisionstatusPath).pipe(
    map(res => res)).subscribe(
    data => {
      this.KeyValueService.decision_sets_update(data);
    },
    error => {
      console.log('in... signin success' + error);
    }
    );
  }

  //this is duplicate of the above, now we dont need validateToken
  // checkForActivation(role, path): Observable<boolean> {
  //   //console.log(this._tokenService.currentUserData+ ' checkForActivation ' + role + ' ' + path);
  // //    KeyValue.animStatus_update('start');
  //   var result2: Observable<boolean> = this._tokenService.validateToken()
  //     .flatMap(u => this.get(KeyValue.api_onboard))
  //     .map(
  //     res1 => {
  // //        KeyValue.animStatus_update('end');
  //       console.log('frm here');
  //       var res = res1.json();
  //       this.setOnboardValues(res)
  //       return this.checkPermissions(role, path);
  //     },
  //     error => {
  //       this._tokenService.signOut();
  //       //console.log('fail');
  // //        KeyValue.animStatus_update('end');
  //       return false;
  //     }

  //     );
  //   return result2;
  // }




  // Event, signs out user if he disgrees terms
  licenceDisagree() {
    //console.log('disagree terms');
    this.licenceRejected = true;
    this.error_msg_agreement_rejected = KeyValue.licence_rejected_msg;
    this.logout();
  }

  canEnableLayoutMenu() {
    //console.log('can enable '+this.licenceRejected);
    if (this.licenceRejected === false && this.init_pwd_changed === true) {
      return false;
    } else {
      return true;
    }

  }

  getChangePasswordPath(): string {
    //console.log(this.getCRole())
    var nickname = this.getCRole()
    if (nickname == 'InstructorAdmin') {
      nickname = "Instructor-Admin"
    }
    return '/' + nickname.toLowerCase() + '/change-password'
  }

  getChangeControlPath(): string {
    //console.log(this.getCRole())
    var nickname = this.getCRole()
    if (nickname == 'InstructorAdmin') {
      nickname = "Instructor-Admin"
    }
    return '/' + nickname.toLowerCase() + KeyValue.workSessionPath;
  }

  isNotStudent() {
    var nickname = this.getCRole()
    if (nickname == 'Student') {
      return false
    } else {
      return true
    }
  }

  isNotAdmin() {
    var nickname = this.getCRole()
    if (nickname == 'Admin') {
      return false
    } else {
      return true
    }
  }

  getChangePath(path): string {
    try {
      let nickname = this.getCRole()
      if (nickname === 'InstructorAdmin') {
        nickname = 'Instructor-Admin';
      }
      return '/' + nickname.toLowerCase() + path;
    } catch (e) {
      console.log('error in getChangePath in authorization service');
      // console.log(e);
    }
  }

  session_running_status(data) {
      const ele = document.getElementById('execution-popup1');
      if (data.current_session.executed === true && !ele.classList.contains('active')) {
        ele.classList.add('active');
        document.getElementById('execution_pop_up').style.display = 'block';
        ele.click();
      }
      if (document.getElementById('session_control') !== null) {
        document.getElementById('session_control').style.display = 'block';
      }
      document.getElementById('session_navbar').style.display = 'block';
  }


  homePath(): string {
    var nickname = this.getCRole()
    if (nickname == 'InstructorAdmin') {
      nickname = "Instructor-Admin"
    }
    return '/' + nickname.toLowerCase()
  }
  // serice method for logout
  logout() {
    console.log('CALLED FROM LOGOUT');
    this._tokenService.signOut().subscribe(
      res => {
        this.router.navigate([KeyValue.signinPath]);
      },
      error => { }//console.log(error)
    );
  }

  setCurrentSession(worksession) {
    const self = this;
    let worksessionJSON = worksession;

    if(typeof worksessionJSON == 'object') {
      console.log(" auth service .. covert json", worksessionJSON)
      worksessionJSON =JSON.stringify(worksession); // Serialize to JSON
    } // Convert to JSON string

    if(worksession != null) {
      this.get(KeyValue.set_current_session, { params: { current_session: worksessionJSON } }).pipe(map(res => res)).subscribe(
        data => {
          console.log("setCurrentSessiondata",data)
          setTimeout(function () {
            KeyValue.update_report_menu(data)
            self.KeyValueService.currentSessionUpdatedOnServer();
          }, 2000);
        },
        () => {
          console.log('error')
          window.location.href ='/'
        }
      );
    }
  }

  setBankDetails() {
    this.work_session = localStorage.getItem('CurrentSession');
    this.setCurrentSession(this.work_session)
  }

  setTeam(team) {
    this.post(KeyValue.api_set_team, { team: team }).pipe(
      map(res => res)).subscribe(
      data => {
        //console.log(data)
      }
      );
  }

  setCurrentDecisionSet(decision_set) {
    const decisionSetJson = JSON.stringify(decision_set); // Serialize to JSON
    this.get(KeyValue.api_current_decision_set, { params: { decision_set: decisionSetJson } }).pipe(map(res => res)).subscribe(
      res => { },
      error => this.router.navigate([KeyValue.signinPath])
    );
  }

  // getFromCache(url: string): Observable<any>{
  //   return new Observable<any>(observer=>{

  //   });
  // }

  get(url: string, options?: any): Observable<any | undefined> {
    const that = this;
    let sskip = false;
    // requests is used to
    // (1) to track api requests that are executing and show/hide loading icon
    // (2) to ignore duplicate requests - sskip var
    if(!that.requests.includes(url)){
      that.requests.push(url);
      console.log('before requests [] .. '+JSON.stringify(that.requests))
    } else {
      console.log(" url call already exists"+JSON.stringify(that.requests))
      return this.CacheService.getInternalStoragedata(sskip, url, that);
      // throw url+" url call already exists"
    }
    console.log("sskip");
    console.log(sskip);
    if(sskip == false){
    if (this.checkForDuplicateTab()) {
      window.location.href = '/';
    }
    else { // else 1
      if (navigator.onLine) {
        const cacheResponse = this.CacheService.checkCache(url, this.requests, this.getCRole.bind(this), KeyValue);
          if (cacheResponse) {
            return cacheResponse;
          }
          // if page is hard refreshed/reloaded cache is set in localstorage
          else {
            localStorage.removeItem(url);
            localStorage.removeItem(url+'_time');
            KeyValue.animStatus_update('start');

            return this.http.get(environment.base_url+url, options).pipe(
              map((response: any) => {
                const ind = that.requests.indexOf(url);
                this.CacheService.getAfterRequest(ind, url, that, KeyValue, response)
                return response;
              }),
              catchError(error => this.handleError(error))
            );
          }
        }
      else {
        return this.showConnectivityError();
      }
    } // else1
    } // sskip
  }

  post(url: string, body: any, options?: any): Observable<any> {
    const that = this;
    if(!that.requests.includes(url)){
      that.requests.push(url);
      console.log('before requests POST [] .. '+JSON.stringify(that.requests))
    }

    if (this.checkForDuplicateTab()) {
      window.location.href = '/';
    }
    else{
      if (navigator.onLine) {
        KeyValue.animStatus_update('start');
        return this.http.post(environment.base_url+url, body, options).pipe(map(
        response => {
          const ind = that.requests.indexOf(url);
          if(ind>-1){
            that.requests.splice(ind,1);
            console.log('after post requests [] .. '+JSON.stringify(that.requests))
          }
          if(that.requests.length==0){
            KeyValue.animStatus_update('end');
          }
          return response
        }),
        catchError(error => this.handleError(error))
        );
      }
      else {
        return this.showConnectivityError();
      }
    }
  }

  handleError(error) {
    if (!navigator.onLine) {
      return this.showConnectivityError();
    } else {
      return this.showServerError(error);
    }
  }

  showConnectivityError() {
    KeyValue.animStatus_update('end');
    window.alert(KeyValue.connectivity_error_message);
    return throwError({ status:0, errors: { name: "Connectivity error" }});
  }

  showServerError(error) {
    KeyValue.animStatus_update('end');
    window.alert(KeyValue.server_error_message);
    return throwError({ status:0, errors: { name: "Server error", error: error }});
  }

  delete(url: string, body: any): Observable<any> {
    if (this.checkForDuplicateTab()) {
      window.location.href = '/';
    }
    else{
      if (navigator.onLine) {
        KeyValue.animStatus_update('start');
        return this.http.delete(environment.base_url+url, body).pipe(map(
        response => {
          KeyValue.animStatus_update('end');
          return response
        }),
        catchError(error => this.handleError(error))
        );
      }
      else {
        return this.showConnectivityError();
      }
    }
  }
}
